// Initialize all Blocky components when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing Blocky components...');
  
  // Check if any Blocky components exist on the page
  const blockyComponents = document.querySelectorAll([
    'blocky-video',
    'blocky-timer',
    'blocky-scroll-to',
    'blocky-product-reviews',
    'blocky-before-after-slider',
    'blocky-image-embedded',
    'blocky-floating-image-with-text',
    'blocky-scrolling-image-bar',
    'blocky-video-embedded'
  ].join(','));

  if (blockyComponents.length > 0) {
    console.log(`Found ${blockyComponents.length} Blocky components on this page`);
    
    // Force reflow/repaint to ensure components are properly initialized
    setTimeout(() => {
      blockyComponents.forEach(component => {
        console.log(`Initializing ${component.tagName.toLowerCase()}`);
        // Trigger a custom event for each component
        component.dispatchEvent(new CustomEvent('blocky:init', {
          bubbles: true,
          detail: { component: component }
        }));
      });
    }, 100);
  } else {
    console.log('No Blocky components found on this page');
  }
});
